import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import project from "./slices/projectSlice";
import cloudchat from "./slices/cloudchatSlice";
import user from "./slices/userSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    project,
    cloudchat,
    user,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
